export const resolveFittingAdVariantMode = ({ variants, preferredMode = 'desktop', availableWidth = 0, allowUnconfigured = false } = {}) => {
  const width = Number(availableWidth)
  if (!variants || width <= 0 || !Number.isFinite(width)) return null
  const fitting = Object.entries(variants).filter(([, variant]) => (
    variant?.width > 0 && variant.width <= width &&
    (allowUnconfigured || !Object.hasOwn(variant, 'adUnitPath') || Boolean(variant.adUnitPath || variant.key))
  ))
  if (fitting.some(([mode]) => mode === preferredMode)) return preferredMode
  return fitting.sort(([, a], [, b]) => b.width - a.width)[0]?.[0] || null
}
